import React from 'react';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import format from 'date-fns/format';
import isValid from 'date-fns/isValid';
import {useTranslation, withTranslation} from 'react-i18next';

const useStyles = makeStyles((theme) => ({
}));

const FieldDate = ({name, scheme, defaultValue, refs}) => {
    const classes = useStyles();
    const { i18n, t } = useTranslation();
    const currentLang = i18n.language;
    const [state, setValue] = React.useState({
        [name]: defaultValue ? defaultValue : null,
    });
    const handleChange = (date) => {
        if (isValid(date)) {
            const dateObj = new Date(date);
            date = format(dateObj, 'yyyy-MM-dd');
        }
        setValue({...state, [name]: date});
    };
    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <input
                type="hidden"
                ref={input => refs[name] = input}
                value={state[name] ? state[name] : ''} />
            <KeyboardDatePicker
                label={currentLang === 'en' ? scheme.label_en : scheme.label}
                format="dd/MM/yyyy"
                value={state[name]}
                onChange={handleChange}
                KeyboardButtonProps={{
                    'aria-label': 'change date',
                }}
                variant="dialog"
                inputVariant="outlined"
                required={scheme.required === true}
                fullWidth
                cancelLabel={t('cancel')}
                okLabel={t('select')}
                size="small"
                invalidDateMessage={t('invalid_date_format')} />
        </MuiPickersUtilsProvider>
    );
};
export default FieldDate;